var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13207 25.3335C6.39859 25.163 5.09999 24.6423 4.22909 23.7714C2.66699 22.2094 2.66699 19.6951 2.66699 14.6668V14.0002C2.66699 8.97184 2.66699 6.4577 4.22909 4.89559C5.79119 3.3335 8.30534 3.3335 13.3337 3.3335H18.667C23.6953 3.3335 26.2095 3.3335 27.7715 4.89559C29.3337 6.4577 29.3337 8.97184 29.3337 14.0002V14.6668C29.3337 19.6951 29.3337 22.2094 27.7715 23.7714C26.2095 25.3335 23.6953 25.3335 18.667 25.3335C17.9197 25.3502 17.3245 25.407 16.7398 25.5402C15.1419 25.908 13.6623 26.7256 12.2002 27.4387C10.1167 28.4546 9.07499 28.9626 8.42125 28.487C7.17058 27.5555 8.39305 24.6694 8.66699 23.3335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame17);
export default __webpack_public_path__ + "static/media/Frame (17).ee313c66311a529ad5cae62f4a10e6c1.svg";
export { ForwardRef as ReactComponent };